jQuery(document).ready(function($) {


    if ($('.reveal-more').length < 1) {
        return;
    }

    $('.reveal-more').each(function(i,el){
        var btnTxt = $(this).attr('data-reveal') ? $(this).attr('data-reveal') : 'Show More';
        var heightLimit = $(this).attr('data-height-limit') ? $(this).attr('data-height-limit') : '200px';
        $(el).append('<div class="reveal-more__button-container"><a href="" class="lyg-button reveal-more__button">' + btnTxt + '</a></div>');


    });

    $('body').click(function(e){
        var btn = $(e.target);
        var container = $(btn).parents('.reveal-more');
        var containerInner = $(container).find('>div').not('.reveal-more__button-container');        
        var revealText = container.attr('data-reveal') ? container.attr('data-reveal') : 'Show More';
        var hideText = container.attr('data-hide') ? container.attr('data-hide') : 'Show Less';
        var heightLimit = container.attr('data-height-limit') ? container.attr('data-height-limit') : '200px';
        var heightFull = container.attr('data-height-full') ? container.attr('data-height-full') : 'auto';

        if ( btn.hasClass('reveal-more__button') ) {
            e.preventDefault();
            container.addClass('expand');
            revealHideMore(btn,containerInner,'reveal-more__button','hide-more__button',hideText,heightFull);
        } else if (btn.hasClass('hide-more__button')) {
            e.preventDefault();
            container.removeClass('expand');
            revealHideMore(btn,containerInner,'hide-more__button','reveal-more__button',revealText,heightLimit);
        }
        
    });
 
    function revealHideMore(btn,container,oldClass,newClass,newText,height) {
        btn.removeClass(oldClass);
        btn.addClass(newClass);
        btn.html(newText);

    }
});